module.exports = __webpack_public_path__ + "static/img/homeRed.40096561.png";